// The `if (!str)` is only useful at runtime, since TS already enforces string at compile time.
export function pascalToCamel(str?: string): string {
  if (!str) return '';
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function camelToPascal(str?: string): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function toWords(str?: string): string {
  if (!str) return '';
  return str.replace(/([A-Z])/g, ' $1').trim();
}
export function toReadableLabel(str?: string): string {
  if (!str) return '';

  return (
    str
      // Example: "UserProfile" → "User Profile"
      // Adds a space between lowercase and uppercase letters (CamelCase)
      .replace(/([a-z])([A-Z])/g, '$1 $2')

      // Example: "Profile2024" → "Profile 2024"
      // Adds a space between letters and numbers
      .replace(/([a-zA-Z])(\d)/g, '$1 $2')

      // Example: "2024DEV1" → "2024 DEV1"
      // Adds a space between numbers and an uppercase block (keeps DEV1 together)
      .replace(/(\d)([A-Z])/g, '$1 $2')

      .trim()
  );
}
